module.exports = __webpack_public_path__ + "static/logo3h-b96740eabf9dee8f095e9e16b36a1b97.png";